import { isNonProfitOrganization } from './check-company-icp';
const FINANCIAL_COOPERATIVE_LEGAL_STRUCTURE_ID = '11c2a2b8-2333-48af-99b2-dbe8d312e701';
const NON_FINANCIAL_COOPERATIVE_LEGAL_STRUCTURE_ID = 'f49c1a14-5b5b-4d1f-b1fd-8eaf93cd1e91';
export const showSmbButton = (_selectedLocale, accessLevel, company) => {
    if (accessLevel === 'custom')
        return false;
    const isCompanyNPO = isNonProfitOrganization(company.legal_structure || '');
    const isCompanyCooperative = company.legal_structure === FINANCIAL_COOPERATIVE_LEGAL_STRUCTURE_ID ||
        company.legal_structure === NON_FINANCIAL_COOPERATIVE_LEGAL_STRUCTURE_ID;
    if (isCompanyNPO || isCompanyCooperative)
        return false;
    const revenue = company.annual_revenue;
    return (revenue === '10m' ||
        revenue === '20m' ||
        revenue === '25m' ||
        revenue === '50m' ||
        revenue === '100m' ||
        revenue === '100m+');
};
